import { Component,OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import ICredencialUsuario from '../models/credencial';
import { ICiudad } from '../models/ciudad';
import { AuthService } from '../services/auth.service';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { CiudadService } from '../services/ciudad.service';
import { MntchofService } from '../services/mntchof.service';
import { Table } from 'primeng/table';
import * as saveAs from 'file-saver';
import { IMes } from '../models/mes';

@Component({
  selector: 'app-mntchof',
  templateUrl: './mntchof.component.html',
  styleUrls: ['./mntchof.component.scss']
})
export class MntchofComponent {
  @ViewChild('dt1') dt!: Table;
  color_gris_deshabilitadas:string = '#D9D9D9';
  user: ICredencialUsuario = {};
  lstCiudades: ICiudad[] = [];

  lstChofer: any = [];
  lstHstEst: any = [];
  valEditAdmin:boolean = true;
  enableEdtMssg:boolean = false;
  loading:boolean=false;
  loading_info:boolean=false;
  loading_texto:boolean=false;
  loading_rpt_est:boolean=false;
  dspReportes: boolean = false;
  dspInfo:boolean=false;
  dbsReportes = false;
  colabInfo:string='';
  dspComentario:boolean=false;
  dsblstCiudades: boolean = false;
  texto_operacion: string = '';
  lstEstatus: any = [
    {id:0, nombre: "Inhabilitado"},
    {id:1, nombre: "Habilitado"}
  ]

  messageForm: FormGroup = new FormGroup({
    cod_chofer: new FormControl(null),
    nombre_completo: new FormControl({value:'',disabled:true}),
    dsc_detalle: new FormControl(null,[Validators.required,Validators.minLength(1),Validators.maxLength(300)]),
    clk_btn: new FormControl(null,Validators.required)
  });

  rptEstChofForm: FormGroup = new FormGroup({
    id_ciudad_hm: new FormControl(null,Validators.required),
    fec_inicio: new FormControl(null,Validators.required),
    fec_fin: new FormControl(null,Validators.required),
  });

  anioReporte:any=null;
  fec_fin_reporte:any=null;
  selectedMesReporte1: IMes = {
    num_mes: -1,
    nombre: ""
  }

  meses: IMes[] = [
    { num_mes: 1, nombre: "Enero" },
    { num_mes: 2, nombre: "Febrero" },
    { num_mes: 3, nombre: "Marzo" },
    { num_mes: 4, nombre: "Abril" },
    { num_mes: 5, nombre: "Mayo" },
    { num_mes: 6, nombre: "Junio" },
    { num_mes: 7, nombre: "Julio" },
    { num_mes: 8, nombre: "Agosto" },
    { num_mes: 9, nombre: "Septiembre" },
    { num_mes: 10, nombre: "Octubre" },
    { num_mes: 11, nombre: "Noviembre" },
    { num_mes: 12, nombre: "Diciembre" }];

  botonExcel:boolean=false;
  IsomeForm = new FormGroup({
        fec_inicio: new FormControl(null,Validators.required),
        fec_fin: new FormControl(null,Validators.required),
        id_ciudad_hm: new FormControl(null,Validators.required),
      });
  reportes = [
    {
      id:0,
      typ_reporte: 2,
      titulo: 'Estatus Colaboradores - Monitoreo',
      descripcion: 'Consulta el estatus de los colaboradores asignados por monitoreo.',
      // fec_inicio: null,
      // fec_fin: null,
      // ciudad: null,
      // anio: null,
      // mes: null,
      frm: this.IsomeForm
    },
    // {
    //   id_reporte: 2,
    //   titulo: 'Kilometraje',
    //   descripcion: 'Reporte de kilometraje en un rango de fechas.',
    //   fec_inicio: null,
    //   fec_fin: null,
    //   ciudad: null
    // },
    // {
    //   id_reporte: 3,
    //   titulo: 'Movimientos de Operación Diaria',
    //   descripcion: 'Detalle de movimientos registrados por fecha.',
    //   fec_inicio: null,
    //   fec_fin: null,
    //   ciudad: null
    // },
    // {
    //   id_reporte: 4,
    //   titulo: 'Criterio de Colaboradores Asignados',
    //   descripcion: 'Reporte de asignaciones filtrado por ciudad y fecha.',
    //   fec_inicio: null,
    //   fec_fin: null,
    //   ciudad: null
    // },
    // {
    //   id_reporte: 5,
    //   titulo: 'Movimientos Operacion Diaria UREA',
    //   descripcion: 'Reporte de Movimientos Operacion Diaria UREA.',
    //   fec_inicio: null,
    //   fec_fin: null,
    //   ciudad: null
    // }
  ];

  constructor(private auth:AuthService,
    private confirmationService:ConfirmationService,
    private messageService:MessageService,
    private ciudadesService:CiudadService,
    private mntService:MntchofService
  )
  {
    this.cargarInformacionUsuario();
    this.cargarConsultaEstChoferes();
  }
  ngOnInit(): void {
    // this.cargarListadoDeSemanasAnio();
    // this.cargarListadoDeCiudadesPrincipales();
    // this.inicializarFechas();
    this.cargarCiudades();
  }
  /*Filtro General para la informacion de tabla*/
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }
  cargarInformacionUsuario() {
    this.user = this.auth.user;
  }

  mostrarDialogoInformativoSinInformacion(mensaje_usuario: string) {
    let mensaje_completo = mensaje_usuario;
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({ key: 'msj', severity: 'info', summary: 'Confirmación', detail: 'Usuario informado de la situación.' });
      },
      key: "sinInformacionDialog"
    });
  }

  cargarCiudades() {
    this.dsblstCiudades = true;
    this.loading = true;
    this.ciudadesService.getListadoCiudades().subscribe((resp) => {
      this.lstCiudades = resp.slice(); // Crear una copia independiente
      const index = this.lstCiudades.findIndex(item => item.nombre === 'TODAS LAS CIUDADES');
      if (index !== -1) {
        this.lstCiudades.splice(index, 1);
      }
      this.lstCiudades.push({ id: 0, nombre: 'TODAS LAS CIUDADES', clave_Estado: '', id_ciudad_principal: 0, clave_tipoTransporte: 0 });
      setTimeout(() => {
        this.loading = false;
        this.dsblstCiudades = false;
      }, 300);
    },
    (error) => {
      this.loading = false;
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Ciudades');
    });
  }
  
  cargarConsultaEstChoferes(){
    this.lstChofer=[]
    this.mntService.getChof(0,1,this.user.cod!).subscribe((resp)=>{
      if(resp.length>0)
        this.lstChofer=resp
      else
        this.mostrarDialogoInformativoSinInformacion('<b>Aviso</b> No existe informacion del Catalogo.');
    },(error)=>{
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> al consultar la información Colaborador OP. Contacte al Administrador.');
    });
  }

  confChngEstatus(data:any){
    let texto_desactivar: string = data.clv_monitoreo == 1 ? 'DESACTIVAR' : 'ACTIVAR';
    let texto_desactivar_header: string = data.clv_monitoreo == 1 ? 'Desactivar' : 'Activar';
             
    this.confirmationService.confirm({
      key:'confirmYN',
      message: 'Esta seguro que desea <b>' + texto_desactivar + '</b> al colaborador <b>' + data.nombre_completo.toUpperCase() + '</b> ?',
      header: 'Confirmacion de ' + texto_desactivar_header,
      icon: 'pi pi-info-circle',
      accept: () => {
        // ruta.clv_disponible = ruta.clv_disponible == 1 ? 0 : 1;
        switch(data.clv_monitoreo)
        {
          case 0:
            this.actEstatus(data);
            break;
          case 1:
            this.inhEstatus(data);
            break;
          default:
            this.messageService.add({ key: 'msj', severity: 'error', summary: 'Cancelado', detail: 'Proceso Cancelado. Contacte al Administrador.' });
            break;
        }
        
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            //prov.clv_activo = estatus_original;
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Proceso Cancelado' });
            break;
          case ConfirmEventType.CANCEL:
            //prov.clv_activo = estatus_original;
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Proceso Cancelado' });
            break;
        }
      }
    });
  }

  actEstatus(data:any){
    let data_enviar= {
        cod_chofer: data.cod_chofer,
        dsc_motivo:'',
        cod_usuario: this.user.cod!
    }
    this.mntService.PutEstChof(data_enviar).subscribe((resp)=>
    {
      if(resp.clv_estatus==-2)      
        setTimeout(() => {
            this.messageService.add({
                severity: 'warn'
                , summary: 'Atención'
                , detail: resp.messageDetails });
            this.cargarConsultaEstChoferes();
            }, 800);
      else
        setTimeout(() => {
            this.messageService.add({ 
                severity: 'success'
                , summary: 'Guardado Exitoso'
                , detail: resp.messageDetails });
            this.cargarConsultaEstChoferes();
            }, 800);
    });
  }

  inhEstatus(data:any){
    this.dspComentario = true;
    this.texto_operacion = 'Inhabilitado de Usuario'
    this.messageForm.controls['cod_chofer']?.setValue(data.cod_chofer);
    this.messageForm.controls['nombre_completo']?.setValue(data.nombre_completo);
    this.messageForm.controls['clk_btn']?.setValue(0);
  }

  guardartexto()
  {
    this.loading_texto=true;
    this.messageForm.controls['clk_btn'].setValue(null);

    let data_enviar ={
      cod_chofer: this.messageForm.controls['cod_chofer']?.value,
      dsc_motivo: this.messageForm.controls['dsc_detalle']?.value,
      cod_usuario: this.user.cod!
    }

    this.mntService.PostEstChof(data_enviar).subscribe((resp)=>{
      if(resp.clv_estatus==-2)
        setTimeout(() => {
            this.messageService.add({
                severity: 'warn'
                , summary: 'Atención'
                , detail: resp.messageDetails });
            this.cargarConsultaEstChoferes();
            }, 800);
      else
        setTimeout(() => {
            this.messageService.add({ 
                severity: 'success'
                , summary: 'Guardado Exitoso'
                , detail: resp.messageDetails });
            this.cargarConsultaEstChoferes();
            this.dspComentario = false;
            //this.messageForm.reset();
            }, 800);
        
      this.loading_texto=false;
    },(error)=>{
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> al Inhabilitar Colaborador OP. Contacte al Administrador.');
      // this.messageService.add({
      //           severity: 'error'
      //           , summary: 'Error en <Inhabilitar Colaborador Op>'
      //           , detail: 'Contacte al Administrador del Sitio' });
      this.dspComentario = false;
      this.loading_texto=false;
    });
  }

  CancelInfo()
  {
    this.dspInfo=false;
    this.lstHstEst=[];
  }

  verHst(data:any){
    this.colabInfo=data.nombre_completo;
    this.mntService.getHstEstatus(data.cod_chofer).subscribe(resp =>{
      if(resp.length==0)
        this.messageService.add({ 
              key: 'msj', 
              severity: 'warn', 
              summary: 'Informacion', 
              detail: 'No se encontro informacion a mostrar.' 
            });
      else{
        this.dspInfo=true;
        this.loading_info=true;

        setTimeout(() => {
          this.lstHstEst=resp;
          this.loading_info=false;
        }, 300);
      }
    },(error)=>{
      this.loading_info=false;
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> al cargar Información. Contacte al Administrador.');
    });
  }

  cancelarVentanaModal()
  {
    this.colabInfo='';
    this.dspComentario=false;
    this.dspReportes=false;
    this.texto_operacion='';
    this.rptEstChofForm.reset();
    this.messageForm.reset();
    this.rptEstChofForm.reset();
  }

  abrirModalReportes() {
    this.dbsReportes = true;
    this.inicializarFechasFormateadasReportes();
  }

  inicializarFechasFormateadasReportes() {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;

    //Reportes
    let num_mes: number = +getMonth;
    this.meses.map((mes) => {
      if (mes.num_mes == num_mes) {
        this.selectedMesReporte1.nombre = mes.nombre;
        this.selectedMesReporte1.num_mes = mes.num_mes;
      }
    });
    this.anioReporte = getYear;
    this.fec_fin_reporte = null;
  }

  exportarExcelEstatusChof(data:any)
  {
    this.loading_rpt_est = true;
    if(this.reportes[data.id].frm.valid){
      this.botonExcel=true;
      let data_enviar= this.reportes[data.id].frm.getRawValue();
      let ctName = data_enviar.id_ciudad_hm! == 0 ? 'General' : this.lstCiudades.find(x=> x.id==data_enviar.id_ciudad_hm!)?.nombre;
      let nameRpt = 'Reporte_Monitoreo_Estatus_Colaborador_OP_'+ctName+'_del_' + data_enviar.fec_inicio! + '_al_' + data_enviar.fec_fin!
      this.mntService.rptEstChof(data_enviar.id_ciudad_hm!,data_enviar.fec_inicio!,data_enviar.fec_fin!).subscribe((resp: any[]) => 
      {
        if (resp.length === 0 || typeof resp === 'undefined') {
          this.mostrarDialogoInformativoSinInformacion(
            '<b>Aviso</b> No se encontro información para la ciudad OP dentro del rango de fechas solicitado.');
          this.loading_rpt_est = false;
          this.botonExcel=false;
        } else {
          import("xlsx").then(xlsx => {
            const worksheet = xlsx.utils.json_to_sheet(resp);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer: any = xlsx.write(workbook, {
              bookType: "xlsx",
              type: "array"
            });
            
          this.saveAsExcelFile(excelBuffer, nameRpt);
          });
          setTimeout(() => {
            this.loading_rpt_est = false;
            this.botonExcel=false;
          }, 500);
        }
      },
      (error) => {
        this.loading_rpt_est = false;
        this.botonExcel=false;
        this.messageService.add({ key: 'msj', severity: 'error'
            , summary: 'Error'
            , detail: 'Error en emitir el reporte de Monitoreo <Estatus Colaboradores OP>.' });
      });
    }else{ 
      this.botonExcel=false;
      this.mostrarDialogoInformativoSinInformacion(
            '<b>Aviso</b> Favor de revisar los campos requeridos para la generacion del excel.');
    }
  }

  verReporte(data: any) {
    this.botonExcel=true;
    switch (data.typ_reporte) {
      case 2:
        this.exportarExcelEstatusChof(data)
        this.botonExcel=true;
        break;
    }
  }

  // cancelarModalReportesIndividual() {
  // this.botonExcel = false;
  // this.reportes = this.reportes.map(rep => ({
  //   ...rep,
  //   fec_inicio: null,
  //   fec_fin: null,
  //   ciudad: null,
  //   mes: null,
  //   anio: null,
  // }));}
  cancelarModalReportes() {
    this.reportes = this.reportes.map(rep => ({
      ...rep,
      // fec_inicio: null,
      // fec_fin: null,
      // ciudad: null,
      // mes: null,
      // anio: null,
      frm: this.IsomeForm
    }));
    this.dbsReportes = false;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    var getYear = new Date().toLocaleDateString('es-MX', { year: 'numeric' });
    var getMonth = new Date().toLocaleDateString('es-MX', { month: '2-digit' });
    var getDay = new Date().toLocaleDateString('es-MX', { day: '2-digit' });
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + "_exportar_" + dateFormat + EXCEL_EXTENSION);
  }
  
}
